import { getVariation } from '@updater-core/lib/optimizely';
import * as sessionMatchers from '../session/session.matchers';

export const GET_VARIATION = 'get_variation';
export const GET_VARIATION_SUCCESS = 'get_variation_success';
export const ACTIVATE_USER = 'activate_user_in_experiment';

export const actions = {
  getVariationSuccess: (payload) => ({
    type: GET_VARIATION_SUCCESS,
    payload,
  }),
  getVariation: (experimentName, activate = true) => ({
    type: GET_VARIATION,
    payload: {
      experimentName,
      activate,
    },
  }),
  activate: (experimentName) => ({
    type: ACTIVATE_USER,
    payload: {
      experimentName,
    },
  }),
};

export function reducer(state = {}, action) {
  if (action.type === GET_VARIATION_SUCCESS) {
    const name = action.payload.experimentName;

    return {
      ...state,
      [name]: {
        ...state[name],
        variation: action.payload.variation,
      },
    };
  }

  return state;
}

export const selectors = {
  getVariation(state, experimentName) {
    return (
      state.experiments &&
      state.experiments[experimentName] &&
      state.experiments[experimentName].variation
    );
  },
};

export function epic() {
  return (action, { dispatch, getState }) => {
    if (
      sessionMatchers.isCreateSuccess(action) ||
      sessionMatchers.isReadSuccess(action)
    ) {
      // place variation calls intended to occur at sign in/up here
    }
    if (action.type === GET_VARIATION) {
      const { experimentName, activate } = action.payload;
      const { experiments = {} } = getState();
      if (
        experiments[experimentName] &&
        experiments[experimentName].variation
      ) {
        return;
      }

      getVariation(experimentName, {}, activate).then((variation) => {
        dispatch(
          actions.getVariationSuccess({
            variation,
            experimentName,
          })
        );
      });
    }
    if (action.type === ACTIVATE_USER) {
      const { experimentName } = action.payload;
      getVariation(experimentName);
    }
  };
}
